import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import * as Yup from "yup";
import { KeyboardDatePicker } from "@material-ui/pickers";
import momentTz from "moment-timezone";

import appRoutes from "../../routes/appRoutes";

import { getFormattedDate, getFormattedMonthDateV2 } from "../../utils/dateTimeHelper";
import { getDoctorInfoMapped, getPatientInfoMapped } from "../../utils/commonMethods";

import Error from "../../components/error";
import Button from "../../components/button";
import ICInput from "../../components/form/input";
import TicketStatuses from "../../components/ticketStatuses";
import CustomModal from "../../components/modal";
import { UncontrolledTooltip } from "reactstrap";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import AddRequestedTestForm from "./addRequestedTestForm";
import Modal from "../../components/modal";
import AttachmentsPdfMerger from "./attachmentsPdfMerger";

const initialValues = {
  patientId: null,
  doctorId: null,
  ticketNo: "",
  dateReceived: "",
  doctor: "",
  status: "",
  patient: "",
  responsible: "",
  subject: "Pathology Request Created",
  message: "",
  doctorNotes: "",
  onHoldDate: ""
};

const EditTicketForm = props => {
  const [ticketData, setTicketData] = useState(initialValues);
  const [disableNotifyDoctor, setDisableNotifyDoctor] = useState(true);
  const [disableMarkAsAction, setDisableMarkAsAction] = useState(true);
  const [disableNotifyPatient, setDisableNotifyPatient] = useState(true);
  const [showRequestTestModal, setShowRequestTestModal] = useState(false);
  const [accessLogModelDoctor, setAccessLogModelDoctor] = useState(false);
  const [accessLogModelPatient, setAccessLogModelPatient] = useState(false);
  const [accessLogModelAction, setAccessLogModelAction] = useState(false);
  const [showTextModal, setShowTextModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const [message, setMessage] = useState('')
  const [fields, setFields] = useState([[{ id: '', message: "" }]])
  const [doctorNotes, setDoctorNotes] = useState([])
  const [selectedNoteActionLog, setSelectedNoteActionLog] = useState([])
  const [editingIndex, setEditingIndex] = useState(null);

  useEffect(() => {
    if (props.data !== null) {
      let data = {
        ticketId: props.data._id
      };
      data.patientId = null;
      data.doctorId = null;

      data.ticketNo = props.data.caseNumber;
      data.dateReceived = getFormattedDate(props.data.dateReceived);
      if (props.data.doctorId === undefined || props.data.doctorId === null) {
        if (props.data.topic === "DOCTOR") {
          data.doctor = "Doctor";
        } else if (props.data.topic === "PATIENT") {
          data.doctor = "Patient";
        } else {
          data.doctor = "Other";
        }
      } else {
        data.doctor = getDoctorInfoMapped(props.data.doctorId);
        data.doctorId = props.data.doctorId._id;
      }

      if (props.data.patientId === undefined || props.data.patientId === null) {
        data.patient = props.data.name;
      } else {
        data.patient = getPatientInfoMapped(props.data.patientId);
        data.patientId = props.data.patientId._id;
      }

      if (props.data.patientId && props.data.patientId.dateOfBirth) {
        data.dateOfBirth = getFormattedMonthDateV2(props.data.patientId.dateOfBirth).format("DD-MM-YYYY");
      }

      data.status = props.data.status ? props.data.status : "";

      data.responsible =
        props.data.responsible !== null ? props.data.responsible._id : "";
      data.subject = props.data.subject ? props.data.subject : "";
      data.message = props.data.message;
      data.doctorNotes = props.data.doctorNotes ? props.data.doctorNotes.map((item, index) => ({
        actionLogs: item.actionLogs,
        doctorId: item.doctorId,
        createdAt: item.createdAt,
        doctorName: "Dr. "+(props.data.doctorId ? props.data.doctorId.firstName : '') + ' ' + (props.data.doctorId ? props.data.doctorId.lastName : ''),
        note: item.note,
        status: item.status,
        id: item._id,
      })) : [];

      if (props.data.onHoldDate) {
        data.onHoldDate = momentTz(props.data.onHoldDate);
      }
      handleNotificationContent(props.data);
      data.resultsReceived = props.data.resultsReceived;
      data.refusedTests = props.data.refusedTests;
      data.requestedTests = props.data.requestedTests;

      // if (data.status === "DOCTOR_ACTION_REQUIRED") {
      //   setDisableMarkAsAction(false)
      // } else {
      //   setDisableMarkAsAction(true)
      // }

      const notes = props.data.adminNotes && props.data.adminNotes.map((item, index) => ({
        id: item._id,
        createdAt: item.createdAt,
        adminName: (item.adminId ? item.adminId.firstName : '') + ' ' + (item.adminId ? item.adminId.lastName : ''),
        adminId: item.adminId ? item.adminId._id : '',
        message: item.note,
      }));

      setFields(notes);

      const doctorNotes = props.data.doctorNotes && props.data.doctorNotes.map((item, index) => ({
        actionLogs: item.actionLogs,
        doctorId: item.doctorId,
        note: item.note,
        doctorName: "Dr. " + (props.data.doctorId ? props.data.doctorId.firstName : '') + ' ' + (props.data.doctorId ? props.data.doctorId.lastName : ''),
        createdAt: item.createdAt,
        status: item.status,
        id: item._id,
      }))
      setDoctorNotes(doctorNotes);

      setTicketData(data);
    }
  }, [props.data]);

  const formik = useFormik({
    initialValues: ticketData,
    doctorNotes,
    fields,
    enableReinitialize: true,
    validationSchema: Yup.object({
      responsible: Yup.string().required("Please select responsible"),
      subject: Yup.string().required("Please select subject"),
      status: Yup.string().required("Please select status"),
      doctorId: Yup.string()
    }),
    onSubmit: values => {
      props.updateTicketData(getFormData(values));
    }
  });

  const handleChange = (e) => {
    setMessage(e.target.value);
  }

  const handleAddNotes = () => {
    const tickitid = props.data._id
    props.addNotes(tickitid, message);
    setMessage('')
  }

  const handleEditChange = (index, e) => {
    const newFields = [...fields];
    newFields[index].message = e.target.value;
    setFields(newFields);
  }

  const handleEditNotes = async (id, message) => {
    const tickitid = props.data._id
    props.editNotes(tickitid, id, message);
    setEditingIndex(null);
  };

  const handleEdit = async (id, index) => {
    setEditingIndex(index)
  };

  const handleDeleteNotes = async (id) => {
    const tickitid = props.data._id
    props.deleteNotes(tickitid, id);
  }

  const handleDoctorAction = (id) => {
    const tickitid = props.data._id
    props.doctoreNotesRequired(tickitid, id);
    // setDisableMarkAsAction(true)
  };

  function getFormData(values) {
    const formData = new FormData();
    formData.append("responsible", values.responsible);
    formData.append("doctorId", values.doctorId);
    // formData.append("message", values.message);
    formData.append("subject", values.subject);
    formData.append("status", values.status);

    for (let item of (values.resultsReceived || [])) {
      formData.append("resultsReceived[]", item);
    }

    for (let item of (values.refusedTests || [])) {
      formData.append("refusedTests[]", item);
    }

    for (let item of (values.requestedTests || [])) {
      formData.append("requestedTests[]", item);
    }

    if (values.onHoldDate && values.status === "ON_HOLD") {
      formData.append("onHoldDate", (values.onHoldDate || momentTz()).toISOString());
    }

    return formData;
  }

  const handleDoctorNotification = (data) => {
    let notificationString = getDoctorNotificationContent();
    props.sendTicketNotification(
      "DOCTOR",
      props.data.doctorId._id,
      props.data.patientId._id,
      notificationString
    );
  };

  const handleNotificationContent = (data) => {
    if (
      data.subject === "Pathology Results Received" ||
      data.subject === "Radiology Report Received" ||
      data.subject === "Specialist Letter Received"
    ) {
      setDisableNotifyDoctor(false);
    } else {
      setDisableNotifyDoctor(true);
    }

    if (
      data.subject === "Pathology Request Created" ||
      data.subject === "Radiology Request Created" ||
      data.subject === "Pathology Results Received" ||
      data.subject === "Radiology Report Received"
    ) {
      setDisableNotifyPatient(false);
    } else {
      setDisableNotifyPatient(true);
    }

    //   let content = "",
    //     patientModelContent = "";

    //   if (
    //     data &&
    //     data.doctorNotifiedBy &&
    //     data.doctorNotifiedBy.length
    //   ) {
    //     // setDoctorNotifiedData(data.doctorNotifiedBy);
    //     data.doctorNotifiedBy.map((value, index) => {
    //       content += `
    //       <div class="row p-0 m-0 text-left">
    //         <div class="col-sm-12 pl-0 mt-1 cursor-pointer" title="${value.notificationId ? value.notificationId.notificationMsg : ''}">
    //           <span class="text-success mr-1"><i class="fas fa-check"></i></span>
    //           <span>${momentTz(value.accessDate)
    //             .tz("Australia/Brisbane")
    //             .format("DD-MM-YYYY hh:mm A")}</span>
    //           <span class="ml-3">${value.adminId.firstName +
    //             " " +
    //             value.adminId.lastName}</span>
    //         </div>
    //       </div>
    //     `;
    //     });
    //   } else {
    //     content += `
    //     <div class="row p-0 m-0">
    //       <div class="col-sm-12 pl-0">
    //         <span>No data found</span>
    //       </div>
    //     </div>
    // `;
    //   }
    //   if (
    //     data &&
    //     data.patientNotifiedBy &&
    //     data.patientNotifiedBy.length
    //   ) {
    //     data.patientNotifiedBy.map((value, index) => {
    //       patientModelContent += `
    //       <div class="row p-0 m-0 text-left">
    //         <div class="col-sm-12 pl-0 mt-1 cursor-pointer" title="${value.notificationId ? value.notificationId.notificationMsg : ''}">
    //           <span class="text-success mr-1"><i class="fas fa-check"></i></span>
    //           <span>${momentTz(value.accessDate)
    //             .tz("Australia/Brisbane")
    //             .format("DD-MM-YYYY hh:mm A")}</span>
    //           <span class="ml-3">${value.adminId.firstName +
    //             " " +
    //             value.adminId.lastName}</span>
    //         </div>
    //       </div>
    //     `;
    //     });
    //   } else {
    //     patientModelContent += `
    //     <div class="row p-0 m-0">
    //       <div class="col-sm-12 pl-0">
    //         <span>No data found</span>
    //       </div>
    //     </div>
    // `;
    //   }

    // setDoctorNotifiedModelBody(content);
    // setPatientNotifiedModelBody(patientModelContent);
  };

  const handlePatientNotification = () => {
    let notificationString = getPatientNotificationContent();
    let isInprogressReportsReceivedAndNotified = false;
    if ((props.data.subject === "Pathology Results Received" || props.data.subject === "Radiology Report Received") && formik.values.status === "IN_PROGRESS") {
      isInprogressReportsReceivedAndNotified = true;
    }
    props.sendTicketNotification(
      "PATIENT",
      props.data.doctorId._id,
      props.data.patientId._id,
      notificationString,
      isInprogressReportsReceivedAndNotified
    );
  };
  const handleMarkAsActioned = (formik) => {
    let data = formik.values
    data.status = "ADMIN_ACTION_REQUIRED"
    data.dateReceived = props.data.dateReceived
    props.sendMarkAsActionedNotification(
      data
    );
    // setDisableMarkAsAction(true)
  };

  const getDoctorNotificationContent = () => {
    let message = "";
    if (props.data.subject === "Pathology Request Created") {
      message = ``;
    } else if (props.data.subject === "Radiology Request Created") {
      message = ``;
    } else if (props.data.subject === "Pathology Results Received") {
      message = `Pathology Results for patient UIN: ${props.data && props.data.patientId && props.data.patientId.patientId
        ? props.data.patientId.patientId
        : ""
        } have been received and are available to view in patients records. Please let us know if you need to discuss these results with the patient or if the results are normal and no follow-up is required. If the results are urgent and you require another doctor to assist, please let us know promptly.`;
    } else if (props.data.subject === "Radiology Report Received") {
      message = `Radiology Report for patient UIN: ${props.data && props.data.patientId && props.data.patientId.patientId
        ? props.data.patientId.patientId
        : ""
        } has been received and is available to view in patients records. Please let us know if you need to discuss this report with the patient or if the report is normal and no follow-up is required. If the report is urgent and you require another doctor to assist, please let us know promptly.`;
    } else if (props.data.subject === "Specialist Letter Received") {
      message = `Specialist letter for patient UIN: ${props.data && props.data.patientId && props.data.patientId.patientId
        ? props.data.patientId.patientId
        : ""
        } has been received and is available to view in patients records. FYI only - no action required.`;
    }
    return message;
  };

  const getPatientNotificationContent = () => {
    let message = "";
    if (props.data.subject === "Pathology Request Created") {
      message = `Your Pathology Results have not been received by our clinic. It has been more than 3 days since our doctor requested the pathology. Please let us know which collection centre you had your pathology request conducted and we will follow-up with them promptly. If you are not proceeding with the test, please let us know and we will cease following you up.`;
    } else if (props.data.subject === "Radiology Request Created") {
      message = `Your Imaging Results have not been received by our clinic. It has been more than 3 days since our doctor requested the imaging. Please let us know which diagnostic centre you had your imaging request conducted and we will follow-up with them promptly. If you are not proceeding with the test, please let us know and we will cease following you up.`;
    } else if (props.data.subject === "Pathology Results Received") {
      message = `Your recent Pathology Results have been received by our clinic. Please request a consult 6am-midnight AEST (available 7 days a week) to discuss your results with any of our doctors. If you have already discussed your results with your regular GP, please let us know and we will cease following you up.`;
    } else if (props.data.subject === "Radiology Report Received") {
      message = `Your recent Radiology Report has been received by our clinic. Please request a consult 6am-midnight AEST (available 7 days a week) to discuss your report with any of our doctors. If you have already discussed your report with your regular GP, please let us know and we will cease following you up.`;
    } else if (props.data.subject === "Specialist Letter Received") {
      message = ``;
    }
    return message;
  };

  const closeAccessLogModel = () => {
    setAccessLogModelDoctor(false);
    setAccessLogModelPatient(false);
  };
  const closeAccessLogActionModel = () => {
    setAccessLogModelAction(false);
  };

  useEffect(() => {
    if (props.data && props.data.subject !== formik.values.subject && formik.values.subject.length) {
      validateAndPush()
    }
  }, [formik.values.subject]);

  async function validateAndPush() {
    await formik.validateForm()

    if (formik.isValid) {
      props.updateTicketSubjectData(getFormData(formik.values));
    }
  }

  const openPR = () => {
    props.goToPatientPMSPortal(formik.values.patientId);
  };

  function onDragEnd(result) {
    const { source, destination } = result;
    if (!destination || destination.droppableId === source.droppableId) {
      return;
    }

    formik.setFieldValue(
      destination.droppableId,
      (formik.values[destination.droppableId] || []).concat(
        formik.values[source.droppableId][source.index]
      )
    );

    formik.setFieldValue(
      source.droppableId,
      (formik.values[source.droppableId] || []).filter(
        (_, index) => index !== source.index
      )
    );
  }

  useEffect(() => {
    if (props.updateSuccess) {
      handleNotificationContent(props.updateSuccess);
    }
  }, [props.updateSuccess]);

  function onRequestedTestsUpdate(result) {
    setShowRequestTestModal(false);
    if (result !== null && result !== undefined) {
      setShowTextModal(true);
      setModalText("Tests added successfully");
      formik.setFieldValue("requestedTests", result);
    }
  }

  return (
    <Fragment>
      <form className="w-100" onSubmit={formik.handleSubmit}>
        <h4 className="mb-4">Update Ticket Details</h4>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">
            Ticket Number: <span className="error">*</span>
          </label>
          <div className="col-sm-5">
            <ICInput
              name="ticketNo"
              type="text"
              value={formik.values.ticketNo}
              disabled
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">
            Date Received: <span className="error">*</span>
          </label>
          <div className="col-sm-5">
            <ICInput
              name="dateReceived"
              type="text"
              value={formik.values.dateReceived}
              disabled
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">
            Doctor: <span className="error">*</span>
          </label>
          <div className="col-sm-5">
            <ICInput
              name="doctor"
              type="text"
              value={formik.values.doctor}
              disabled
              customCssClass="yellow-hover-color"
              onClick={e => {
                props.goToDoctorProfile(formik.values.doctorId);
              }}
            />
          </div>
          <div className="col-sm-3">
            <Button
              disabled={disableNotifyDoctor}
              className="float-left"
              title="Notify Doctor"
              type="button"
              clickEvent={handleDoctorNotification}
            />
            <i
              className="fas fa-file cursor-point fa-2x cursor-pointer insta-link-orange ml-2 float-left mt-1"
              onClick={() => setAccessLogModelDoctor(true)}
            ></i>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">
            Patient: <span className="error">*</span>
          </label>
          <div className="col-sm-5">
            <div onClick={openPR}>
              {/* <ICInput
              name="patient"
              type="text"
              value={formik.values.patient}
              disabled
                customCssClass="yellow-hover-color"
            /> */}
              <label className="pt-1 w-100 yellow-hover-color disable-type-input">
                {formik.values.patient}
              </label>
            </div>
          </div>
          <div className="col-sm-3">
            <Button
              disabled={disableNotifyPatient}
              className="float-left"
              title="Notify Patient"
              type="button"
              clickEvent={handlePatientNotification}
            />
            <i
              className="fas fa-file cursor-point fa-2x cursor-pointer insta-link-orange ml-2 float-left mt-1"
              onClick={() => setAccessLogModelPatient(true)}
            ></i>
          </div>
        </div>

        {
          ticketData.dateOfBirth && (<div className="form-group row">
            <label className="col-sm-2 col-form-label">
              Date of Birth: <span className="error">*</span>
            </label>
            <div className="col-sm-5">
              <ICInput
                name="dateOfBirth"
                type="text"
                value={ticketData.dateOfBirth}
                disabled
              />
            </div>
          </div>)
        }

        <hr className="mt-4 mb-4" />

        <div className="form-group row">
          <label className="col-sm-2 col-form-label">
            Ticket Status: <span className="error">*</span>
          </label>
          <div className="col-sm-5">
            <TextField
              name="status"
              className="w-100"
              select
              value={formik.values.status}
              SelectProps={{
                native: true
              }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.status && formik.errors.status ? true : false
              }
              helperText={
                formik.touched.status && formik.errors.status
                  ? formik.errors.status
                  : ""
              }
            >
              <option value="">Select a Status</option>
              <TicketStatuses exclude={["DOCTOR_ACTION_REQUIRED"]} />
            </TextField>
          </div>
          {formik.values.status === "ON_HOLD" && (
            <div className="col-sm-5">
              <KeyboardDatePicker
                name="onHoldDate"
                style={{ width: "150px" }}
                autoOk
                variant="inline"
                mask="__-__-____"
                format="DD-MM-YYYY"
                value={formik.values.onHoldDate}
                onChange={date => {
                  formik.setFieldValue("onHoldDate", date);
                }}
              />
            </div>
          )}
        </div>

        <div className="form-group row">
          <label className="col-sm-2 col-form-label">
            Responsible: <span className="error">*</span>
          </label>
          <div className="col-sm-5">
            <TextField
              name="responsible"
              className="w-100"
              select
              value={formik.values.responsible}
              SelectProps={{
                native: true
              }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.responsible && formik.errors.responsible
                  ? true
                  : false
              }
              helperText={
                formik.touched.responsible && formik.errors.responsible
                  ? formik.errors.responsible
                  : ""
              }
            >
              <option value="">Select a Responsible</option>
              {props.staffList.map(staff => (
                <option key={staff.id} value={staff.id}>
                  {staff.name}
                </option>
              ))}
            </TextField>
          </div>
        </div>

        <hr className="mt-4 mb-4" />

        <h4 className="mb-4">Ticket Details</h4>

        <div className="form-group row">
          <label className="col-sm-2 col-form-label">
            Subject: <span className="error">*</span>
          </label>
          <div className="col-sm-5">
            <TextField
              name="subject"
              className="w-100"
              select
              value={formik.values.subject}
              SelectProps={{
                native: true
              }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.subject && formik.errors.subject ? true : false
              }
              helperText={
                formik.touched.subject && formik.errors.subject
                  ? formik.errors.subject
                  : ""
              }
            >
              <option value="">Select Subject</option>
              <option value="Pathology Request Created">
                Pathology Request Created
              </option>
              <option value="Radiology Request Created">
                Radiology Request Created
              </option>
              <option value="Pathology Results Received">
                Pathology Results Received
              </option>
              <option value="Radiology Report Received">
                Radiology Report Received
              </option>
              <option value="Specialist Letter Received">
                Specialist Letter Received
              </option>
            </TextField>
          </div>
        </div>
        {/* <div className="form-group row">
          <label className="col-sm-2 col-form-label">Message:</label>
          <div className="col-sm-5">
            <TextField
              name="message"
              className="w-100 dynamic-textarea"
              multiline
              value={formik.values.message}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.message && formik.errors.message ? true : false
              }
              helperText={
                formik.touched.message && formik.errors.message
                  ? formik.errors.message
                  : ""
              }
            />
          </div>
        </div> */}


        <div className="form-group row">
          <label className="col-sm-2 col-form-label">Notes:</label>
          <div className="col-sm-6">
            {fields.map((field, index) => (
              <>
                <div key={field.id} className="d-flex">
                  <TextField
                    name={`message-${index}`}
                    type="text"
                    value={field.message}
                    style={{ margin: "2px", flex: 1 }}
                    disabled={editingIndex !== index}
                    onChange={(e) => handleEditChange(index, e)}
                    multiline
                    rows={4}
                    fullWidth
                  />

                  {editingIndex === index && (
                    <button
                      className="mb-1 mr-1"
                      type="button"
                       style={{
                        backgroundColor: '#f5ab35',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        padding: '5px',
                        outline: 'none',
                        height: '45px',
                        width: '45px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginLeft: '10px', 
                      }}
                      onClick={() => handleEditNotes(field.id, field.message)}
                    >
                      <i class="fa fa-check-circle" aria-hidden="true"></i>
                    </button>
                  )}

                  {editingIndex !== index && ((props.currentUserId === field.adminId) || (props.currentUserId !== field.adminId && props.currentUserType !== "SUPPORT_STAFF")) && (
                    <button
                      className="mb-1 mr-1"
                      type="button"
                      style={{
                        backgroundColor: '#f5ab35',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        padding: '5px',
                        height: '45px',
                        width: '45px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginLeft: '10px',
                      }}
                      onClick={() => handleEdit(field.id, index)}
                    >
                      <i class="fa fa-pencil-alt" aria-hidden="true"></i>
                    </button>
                  )}

                  {
                    ((props.currentUserId === field.adminId) || (props.currentUserId !== field.adminId && props.currentUserType !== "SUPPORT_STAFF")) && (
                      <button
                        className="mb-1"
                        type="button"
                        style={{
                          backgroundColor: '#f5ab35',
                          color: 'white',
                          border: 'none',
                          borderRadius: '5px',
                          padding: '5px',
                          height: '45px',
                          width: '45px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginLeft: '10px',
                        }}
                        onClick={() => handleDeleteNotes(field.id)}
                      >
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    )
                  }
                </div>
                {
                  field.message && (
                    <div style={{ marginBottom: "10px" }} className="fa-sm"> {momentTz(field.createdAt).tz("Australia/Brisbane").format('dddd, Do MMM YYYY h:mmA')} AEST by {field.adminName}</div>
                  )
                }
              </>
            ))}
            <div className="row">
              <div className="col-sm-12 d-flex">
                <TextField
                  name="message"
                  value={message}
                  onChange={handleChange}
                  multiline
                  rows={4}
                  fullWidth
                />
                <button
                  className="mb-4 mr-1 ml-5"
                  type="button"
                  style={{
                    backgroundColor: '#f5ab35',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    padding: '5px',
                    height: '45px',
                    width: '45px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginLeft: '10px',
                  }}
                  onClick={handleAddNotes}
                >
                  <i className="fa fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <DragDropContext onDragEnd={onDragEnd}>
          <div className="form-group row">
            <label className="col-sm-2 col-form-label">Tests Requested:</label>
            <div className="col-sm-5">
              <Droppable
                key="requestedTests"
                droppableId="requestedTests"
                className="d-flex flex-row flex-wrap"
              >
                {(provided, snapshot) => (
                  <div
                    style={
                      snapshot.isDraggingOver
                        ? { border: "2px solid #74d833", borderRadius: "5px" }
                        : { border: "2px solid #f5ab35", borderRadius: "5px" }
                    }
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="d-flex flex-row flex-wrap"
                  >
                    {formik.values.requestedTests &&
                      formik.values.requestedTests.length > 0
                      ? formik.values.requestedTests.map((tag, index) => (
                        <Draggable key={tag} draggableId={tag} index={index}>
                          {(provided, snapshot) => (
                            <div
                              className="tag"
                              key={index}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              {tag}&nbsp;
                            </div>
                          )}
                        </Draggable>
                      ))
                      : <p className="p-1">Drag and drop tests here</p>}
                  </div>
                )}
              </Droppable>
            </div>

            {/* <Button
              className="float-left"
              title="Mark as Actioned"
              type="button"
              clickEvent={() => setShowRequestTestModal(true)}
            /> */}
          </div>

          <div className="form-group row">
            <label className="col-sm-2 col-form-label">Results Received:</label>
            <div className="col-sm-5">
              <Droppable
                className="d-flex flex-row flex-wrap"
                key="resultsReceived"
                droppableId="resultsReceived"
              >
                {(provided, snapshot) => (
                  <div
                    style={
                      snapshot.isDraggingOver
                        ? { border: "2px solid #74d833", borderRadius: "5px" }
                        : { border: "2px solid #f5ab35", borderRadius: "5px" }
                    }
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="d-flex flex-row flex-wrap"
                  >
                    {formik.values.resultsReceived &&
                      formik.values.resultsReceived.length > 0
                      ? formik.values.resultsReceived.map((tag, index) => (
                        <Draggable key={tag} draggableId={tag} index={index}>
                          {(provided, snapshot) => (
                            <div
                              className="tag"
                              key={index}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              {tag}&nbsp;
                            </div>
                          )}
                        </Draggable>
                      ))
                      : <p className="p-1">Drag and drop tests here</p>}
                  </div>
                )}
              </Droppable>
            </div>
          </div>

          <div className="form-group row">
            <label className="col-sm-2 col-form-label">Tests Refused:</label>
            <div className="col-sm-5">
              <Droppable
                className="d-flex flex-row flex-wrap"
                key="refusedTests"
                droppableId="refusedTests"
              >
                {(provided, snapshot) => (
                  <div
                    style={
                      snapshot.isDraggingOver
                        ? { border: "2px solid #74d833", borderRadius: "5px" }
                        : { border: "2px solid #f5ab35", borderRadius: "5px" }
                    }
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="d-flex flex-row flex-wrap "
                  >
                    {formik.values.refusedTests &&
                      formik.values.refusedTests.length > 0
                      ? formik.values.refusedTests.map((tag, index) => (
                        <Draggable key={tag} draggableId={tag} index={index}>
                          {(provided, snapshot) => (
                            <div
                              className="tag"
                              key={index}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              {tag}&nbsp;
                            </div>
                          )}
                        </Draggable>
                      ))
                      : <p className="p-1">Drag and drop tests here</p>}
                  </div>
                )}
              </Droppable>
            </div>
          </div>
        </DragDropContext>
        <AttachmentsPdfMerger
          attachments={props.data && props.data.attachments}
          ticketId={props.data && props.data._id}
          mergedAttachment={props.data && props.data.mergedAttachment}
          onMergeSuccess={props.onMergeSuccess}
        />
        {/* <div className="form-group row">
          <label className="col-sm-2 col-form-label">Doctor Notes:</label>
          <div className="col-sm-5">
            <TextField
              name="doctorNotes"
              className="w-100 dynamic-textarea"
              style={
                props.data && props.data.status == "DOCTOR_ACTION"
                  ? { border: "2px solid pink", borderRadius: "5px" }
                  : { border: "2px solid #f5ab35", borderRadius: "5px" }
              }
              multiline
              disabled
              value={formik.values.doctorNotes}
            />
            {props.data?.doctorNotesUpdatedAt && (
              <div>
                {momentTz(props.data.doctorNotesUpdatedAt)
                  .tz("Australia/Brisbane")
                  .format('dddd, Do MMM YYYY h:mmA')} AEST by
                {" Dr " + props.data.doctorId.firstName +
                  " " +
                  props.data.doctorId.lastName}
              </div>
            )}
          </div>
          <Button
            disabled={disableMarkAsAction}
            className={`float-left ${formik.values.status === "ADMIN_ACTION" ? "gray m-0" : ""}`.trim()}
            title={
              formik.values.status === "ADMIN_ACTION" ? "Marked as Actioned" : "Mark as Actioned"
            }
            type="button"
            clickEvent={() => handleMarkAsActioned(formik)}
          />
          <i
            className={`fas fa-file cursor-point fa-2x cursor-pointer ml-2 float-left mt-1 ${formik.values.status === "ADMIN_ACTION" ? "custom-link" : "insta-link-orange"
              }`}
            onClick={() => setAccessLogModelAction(true)}
          ></i>
        </div> */}

        <div className="form-group row">
          <label className="col-sm-2 col-form-label">Doctor Notes:</label>
          <div className="col-sm-7">
            <div className="row">
              {
                !doctorNotes.length && (
                  <p className="ml-3 mt-2">N/A</p>
                )
              }
              {doctorNotes.map((field, index) => (
                <>
                  <div className="col-sm-12 d-flex mt-2">
                      <TextField
                        name="doctorNotes"
                        className="w-100 dynamic-textarea mr-2"
                        style={field.status === "ADMIN_ACTION_REQUIRED" ? { border: "2px solid pink", borderRadius: "5px" } : (field.status === "DOCTOR_ACTION_REQUIRED" ? { border: "2px solid #f5ab35", borderRadius: "5px" } : {})}
                        multiline
                        disabled
                        value={field.note}
                      />
                      {props.data?.doctorNotesUpdatedAt && (
                        <div>
                        {momentTz(field.createdAt)
                            .tz("Australia/Brisbane")
                            .format('dddd, Do MMM YYYY h:mmA')} AEST by
                        {field.doctorName}
                        </div>
                      )}


                    {
                      field.status !== 'RESOLVED' && (
                        <Fragment>
                          <Button
                            disabled={field.status === 'NONE' || field.status === 'DOCTOR_ACTION_REQUIRED' || field.status === 'RESOLVED'}
                            className={`float-left ticket-action-btns ${field.status !== "ADMIN_ACTION_REQUIRED" ? "gray m-0" : ""}`.trim()}
                            title={
                              field.status === 'NONE' || field.status === "ADMIN_ACTION_REQUIRED" ? "Mark as Actioned" : "Marked as Actioned"
                            }
                            type="button"
                            clickEvent={() => handleDoctorAction(field.id)}
                          />
                        </Fragment>
                      )
                    }

                    {
                      field.status === 'RESOLVED' && (
                        <Fragment>
                          <Button
                            disabled={true}
                            className={`float-left ticket-action-btns ${field.status !== "ADMIN_ACTION_REQUIRED" ? "gray m-0" : ""}`.trim()}
                            title={`Marked As Resolved`}
                            type="button"
                            clickEvent={() => handleDoctorAction(field.id)}
                          />
                        </Fragment>
                      )
                    }
                    <i
                      className={`fas fa-file cursor-point fa-2x cursor-pointer ml-2 float-left mt-1 insta-link-orange`}
                      onClick={() => { setSelectedNoteActionLog(field.actionLogs); setAccessLogModelAction(true); }}
                    ></i>
                  </div>
                  <div className="col-sm-12 d-flex fa-sm mt-2"> {momentTz(field.createdAt).tz("Australia/Brisbane").format('dddd, Do MMM YYYY h:mmA')} AEST by {field.doctorName}</div>
                </>
              ))}
            </div>
          </div>
        </div>

        <Error>{props.errorMessage}</Error>
        <br />
        <div className="d-flex flex-row flex-wrap justify-content-center mt-4">
          <Button className="mb-4" title="Save" type="submit" />
          <Link
            className="insta-button-primary ml-3 mr-3 mb-4"
            to={appRoutes.viewTickets}
          >
            Back
          </Link>
          <button
            onClick={e => props.deleteTicket(true)}
            type="button"
            className="btn btn-out-delete mb-4"
          >
            <i className="fas fa-trash-alt"></i>
          </button>
        </div>
      </form>
      {/* <Model
        openModal={accessLogModelDoctor}
        modalBodyContent={doctorNotifiedModelBody}
        okayText="Okay"
        cancelText="Okay"
        title={"Doctor Notified"}
        useOneButton={true}
        okayEvent={closeAccessLogModel}
        cancelEvent={closeAccessLogModel}
      /> */}
      {/* <Model
        openModal={accessLogModelPatient}
        modalBodyContent={patientNotifiedModelBody}
        okayText="Okay"
        cancelText="Okay"
        title={"Patient Notified"}
        useOneButton={true}
        okayEvent={closeAccessLogModel}
        cancelEvent={closeAccessLogModel}
      /> */}
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        title="Doctor Notified"
        openModal={accessLogModelDoctor}
        cancelEvent={closeAccessLogModel}
        okayEvent={closeAccessLogModel}
        modalBodyContent={
          props.updateSuccess && props.updateSuccess.doctorNotifiedBy && props.updateSuccess.doctorNotifiedBy.length ? props.updateSuccess.doctorNotifiedBy.map((value, index) => {
            return (
              <div key={index} className="row p-0 m-0 text-left">
                <div
                  className="col-sm-12 pl-0 mt-1 cursor-pointer"
                  id={"toolTipId" + index}
                >
                  <span className="text-success mr-1">
                    <i className="fas fa-check"></i>
                  </span>
                  <span>
                    {momentTz(value.accessDate)
                      .tz("Australia/Brisbane")
                      .format("DD-MM-YYYY hh:mm A")}
                  </span>
                  <span className="ml-3">
                    {
                      value.adminId.firstName === "System" && value.adminId.lastName === "System" ? (
                        "Automated | Instant Consult"
                      ) : (
                        value.adminId.firstName + " " + value.adminId.lastName
                      )
                    }
                  </span>
                  {/* <span className="ml-3">
                    {value.adminId.firstName + " " + value.adminId.lastName}
                  </span> */}
                  <UncontrolledTooltip
                    placement="top"
                    target={"toolTipId" + index}
                  >
                    {value.notificationId
                      ? value.notificationId.notificationMsg
                      : ""}
                  </UncontrolledTooltip>
                </div>
              </div>
            );
          }) : <p>No Data Found</p>
        }
      />
      <CustomModal
        noFooterButtons={true}
        title="Additional Tests Requested"
        openModal={showRequestTestModal}
        cancelEvent={() => setShowRequestTestModal(false)}
        okayEvent={() => setShowRequestTestModal(false)}
        modalBodyContent={
          <AddRequestedTestForm ticketId={ticketData.ticketId} onRequestedTestsUpdate={onRequestedTestsUpdate} />
        }
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        title="Patient Notified"
        openModal={accessLogModelPatient}
        cancelEvent={closeAccessLogModel}
        okayEvent={closeAccessLogModel}
        modalBodyContent={
          props.updateSuccess && props.updateSuccess.patientNotifiedBy && props.updateSuccess.patientNotifiedBy.length ? props.updateSuccess.patientNotifiedBy.map((value, index) => {
            return (
              <div key={index} className="row p-0 m-0 text-left">
                <div
                  className="col-sm-12 pl-0 mt-1 cursor-pointer"
                  id={"toolTipId" + index}
                >
                  <span className="text-success mr-1">
                    <i className="fas fa-check"></i>
                  </span>
                  <span>
                    {momentTz(value.accessDate)
                      .tz("Australia/Brisbane")
                      .format("DD-MM-YYYY hh:mm A")}
                  </span>
                  <span className="ml-3">
                    {
                      value.adminId.firstName === "System" && value.adminId.lastName === "System" ? (
                        "Automated | Instant Consult"
                      ) : (
                        value.adminId.firstName + " " + value.adminId.lastName
                      )
                    }
                  </span>
                  <UncontrolledTooltip
                    placement="bottom"
                    target={"toolTipId" + index}
                    fade={true}
                  >
                    {value.notificationId
                      ? value.notificationId.notificationMsg
                      : ""}
                  </UncontrolledTooltip>
                </div>
              </div>
            );
          }) : <p>No Data Found</p>
        }
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        title="Action Required Log"
        openModal={accessLogModelAction}
        cancelEvent={closeAccessLogActionModel}
        okayEvent={closeAccessLogActionModel}
        modalBodyContent={
          selectedNoteActionLog &&
          selectedNoteActionLog?.length > 0 ? (
            selectedNoteActionLog
                // .sort((a, b) => new Date(a.accessDate) - new Date(b.accessDate)) // Sort by date, oldest first
              .map((log, index) => {
                const user = log.adminId || log.doctorId; // Determine whether it's admin or doctor
                const isAdmin = !!log.adminId; // Check if the log is for an admin
                const userName =
                  user.firstName === "System" && user.lastName === "System"
                    ? "Automated | Instant Consult"
                    : `${log.doctorId ? "Dr. " : ""}${user.firstName} ${user.lastName}`; // Add Dr. prefix if it's a doctor
                const status = log.extras.status;
                let notificationText;
                if (status === "ADMIN_ACTION_REQUIRED") {
                  notificationText = `Support Team Notified`;
                } else if (status === "DOCTOR_ACTION_REQUIRED") {
                  notificationText = `Marked As Actioned`;
                } else if (status === "RESOLVED") {
                  notificationText = `Marked As Resolved`;
                } else {
                  notificationText = `Other Action`;
                }

                return (
                  <div key={index} className="row p-0 m-0 text-left">
                    <div
                      className="col-sm-12 pl-0 mt-1 cursor-pointer"
                      id={`toolTipId${index}`} // Unique ID for tooltip
                    >
                      <span className="text-success mr-1">
                        <i className="fas fa-check"></i>
                      </span>
                      <span>
                        {momentTz(log.createdAt)
                          .tz("Australia/Brisbane")
                          .format("DD-MM-YYYY hh:mm A")}
                      </span>
                      <span className="ml-3">{userName}</span>
                      <UncontrolledTooltip
                        placement="bottom"
                        target={`toolTipId${index}`}
                        fade={true}
                      >
                        {notificationText}
                      </UncontrolledTooltip>
                    </div>
                  </div>
                );
              })
          ) : (
            <p>No Data Found</p>
          )
        }
      />
      <Modal
        useOneButton={true}
        cancelText="Okay"
        openModal={showTextModal}
        cancelEvent={() => {
          setShowTextModal(false);
          setModalText("");
        }}
        modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
      />
    </Fragment>
  );
};

export default EditTicketForm;

EditTicketForm.defaultProps = {
  errorMessage: ""
};

EditTicketForm.propTypes = {
  data: PropTypes.object,
  staffList: PropTypes.array.isRequired,
  deleteTicket: PropTypes.func.isRequired,
  updateTicketData: PropTypes.func.isRequired,
  goToPatientPMSPortal: PropTypes.func,
  goToDoctorProfile: PropTypes.func,
  errorMessage: PropTypes.string
};
